/* el-filtration.js — sections/el-filtration.liquid
   Filtration steps: one open at a time; clicking the open step closes it. */
(function () {
  'use strict';

  function setOpen(step, open) {
    var toggle = step.querySelector('[data-el-step-toggle]');
    var panel = step.querySelector('.el-filtration__step-panel');
    step.classList.toggle('is-open', open);
    if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (panel) panel.hidden = !open;
  }

  /* Smooth version: the step slides open / shut (el-accordion-motion.js) */
  function slide(step, open) {
    if (!window.elToggleHeight) { setOpen(step, open); return; }
    window.elToggleHeight(step, step.querySelector('.el-filtration__step-panel'), function (o) { setOpen(step, o); }, open);
  }

  function closeOthers(section, keep, animate) {
    section.querySelectorAll('[data-el-step].is-open').forEach(function (s) { if (s !== keep) (animate ? slide : setOpen)(s, false); });
  }

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-el-step-toggle]');
    if (!toggle) return;
    var step = toggle.closest('[data-el-step]');
    var section = toggle.closest('[data-el-filtration]');
    if (!step || !section) return;
    var willOpen = !step.classList.contains('is-open');
    closeOthers(section, step, true);
    slide(step, willOpen);
  });

  /* Theme editor: open the step being edited */
  document.addEventListener('shopify:block:select', function (event) {
    var step = event.target.closest && event.target.closest('[data-el-step]');
    var section = step && step.closest('[data-el-filtration]');
    if (!section) return;
    closeOthers(section, step);
    setOpen(step, true);
  });
})();
